import Vue from "vue";
import Vuex from "vuex";
import login from "@/store/modules/login";
import logout from "@/store/modules/logout";
import upd_search from "@/store/modules/upd_search";
import check from "@/store/modules/check";
import ukd from "@/store/modules/ukd";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    login,
    upd_search,
    logout,
    check,
    ukd,
  },
  getters: {},
});
